import { render, staticRenderFns } from "./ExpancionHeader.vue?vue&type=template&id=10f0f64e&scoped=true&v-slot=%7B%20open%20%7D&"
import script from "./ExpancionHeader.vue?vue&type=script&lang=js&"
export * from "./ExpancionHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExpancionHeader.vue?vue&type=style&index=0&id=10f0f64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0f64e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VExpansionPanelHeader,VIcon,VProgressCircular,VSpacer})
